<template>
  <div class="footer">
    <div class="footer-wrap clearfix">
      <div class="contact-wrap pull-left">
        <p class="title">联系我们</p>
        <ul class="contact-list">
          <li
            class="contact-item clearfix"
            v-for="(item, index) in contactList"
            :key="index"
          >
            <img :src="item.src" alt="" class="contact-icon pull-left" />
            <div class="pull-left contact-info">
              <p class="info-title">{{ item.title }}</p>
              <p class="info-value">{{ item.value }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="contact-wx pull-right">
        <p class="title">项目合作二维码</p>
        <img src="images/wxchat.png" alt="" />
      </div>
    </div>
    <div class="record">
      <a class="" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
        >沪ICP备2021023200号-1</a
      >
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402010207"
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px;
          line-height: 20px;
        "
      >
        <img src="images/filings.png" style="float: left" />
        <p
          style="
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #939393;
          "
        >
          沪公网安备 31011402010207号
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      contactList: [
        {
          src: "./images/icons/phone@2x.png",
          title: "手机号",
          value: "16602118207",
        },
        {
          src: "./images/icons/email.png",
          title: "邮箱",
          value: "shaoxiaohua@phixsoul.com",
        },
        {
          src: "./images/icons/vx@2x.png",
          title: "微信（手机同号）",
          value: "16602118207",
        }
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 448px;
  background-color: #292931;
  color: #fff;
  font-size: 14px;
}

.footer-wrap {
  width: 1200px;
  height: calc(100% - 80px);
  padding: 48px 0;
  margin: auto;

  .contact-wrap {
    width: 70%;
  }

  .contact-wx {
    width: 20%;

    img {
      width: 160px;
      height: 160px;
    }
  }

  .title {
    position: relative;
    margin-bottom: 58px;
    font-size: 16px;
    &::after {
      content: "";
      position: absolute;
      bottom: -16px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #ec1c24;
    }
  }

  .contact-list {
    display: flex;
    height: 200px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
  }
}

.contact-item {
  display: inline-block;
  width: 60%;
  height: 88px;
  padding: 16px;
  background-color: rgba(#808080, 0.1);

  &:nth-child(2n + 1) {
    width: 36%;
  }

  .contact-icon {
    width: 30px;
    height: 30px;
    margin-right: 16px;
  }

  .info-title {
    margin-bottom: 10px;
    color: #fff;
    opacity: 0.5;
  }

  .info-value {
    line-height: 25px;
    font-size: 18px;
  }
}

.record {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 80px;
  padding-top: 20px;
  background-color: #212128;
  // line-height: 80px;
  text-align: center;
  color: #9a9a9a;
  font-size: 14px;
}

.record a {
  display: block;
  margin-bottom: 10px;
  color: #939393;
}
</style>

